<template>
  <div>
    <alert ref='alert'/>
    <div v-if='showSpinner' class='loader-wrapper'>
      <div class='loader'></div>
    </div>
    <deal-information
      v-bind:type="'deal'"
      :shownTypes="['STACR','CAS', 'ILN']"
      :validDeal.sync='validDeal'
      :report1='report1'
      @cashflow-generated='onCashflowGenerated'
      @deal-fetched='onDealFetched'
      @settlementDateChange='onSettlementDateChange'
      @scenarioChange='scenario = $event'
      @show-spinner='showSpinner = true'
      @hide-spinner='showSpinner = false'
    />
    <div v-if='validDeal'>
      <!-- <collateral-remit-history v-if="this.$store.getters.dealName.startsWith('STACR')"
        :history="collateralRemitHistory"
        @load="loadCollateralRemitHistory"/> -->
      <capital-structure v-bind:bonds='bondsInfo'/>
      <cashflows
        ref='cashflowsComponent'
        :collateralCashflow='collateralCashflow'
        :miscVariables='miscVariables'
        :bondsCashflows='bondsCashflows'
        :collateralInfo='collateralInfo'
        :bondsInfo='bondsInfo'
        :scenario='scenario'
        :runDate='runDate'
      />
    </div>
  </div>
</template>

<script>
import service                from '../../services/HttpRequestService';
import DealInformation        from '../dealInformation/';
import CapitalStructure       from './CapitalStructure';
import CollateralRemitHistory from './CollateralRemitHistory';
import Cashflows              from './Cashflows';
import formatter              from '../../utilities/Formatter';
import Alert                  from '../Alert';
import ReportsNames           from '@/constants/reportsNames';

export default {
  data() {
    return {
      collateralCashflow:     [],
      bondsCashflows:         [],
      collateralInfo:         {},
      bondsInfo:              {},
      collateralHistory:      [],
      collateralRemitHistory: [],
      showSpinner:            false,
      validDeal:              false,
      scenario:               null,
      runDate:                null,
      miscVariables:          []
    };
  },
  computed: {
    report1() {
      return {
        pReportName:          ReportsNames.Historical.DEAL,
        pReportParams:        [
          {
            'DbName': 'deal',
            'Value':  this.$route.query.dealName
          }
        ],
        flagShowOwnRunButton: false,
        pLabelRunButton:      `Run ${ReportsNames.Historical.DEAL} Report`
        //triggerRunReport:     false, // SHOULD BE DEFINED IN CHILD DATA
      };
    }
  },
  created() {
    this.collateralCashflow = this.$store.getters.dealCashflow.collateralCashflow || [];
    this.bondsCashflows     = this.$store.getters.dealCashflow.bondsCashflows || [];
    this.collateralInfo     = this.$store.getters.dealCashflow.collateralInfo || {};
    this.bondsInfo          = this.$store.getters.dealCashflow.bondsInfo || {};
  },
  methods:    {
    async loadCollateralHistory() {
      this.showSpinner = true;
      try {
        let res                = await service.getCollateralHistory(this.$store.getters.dealName);
        this.collateralHistory = formatter.formatDataInArray(
          res.data.CollateralHistory,
          ['CurrentBalance', 'OriginalBalance'],
          ['Date'],
          ['Delinquency30', 'Delinquency60', 'Delinquency90Plus'],
          []
        );
        for (let row of this.collateralHistory) {
          row.LoansCount = formatter.formatDollarValue(row.LoansCount, 0);
        }
      } catch (err) {
        await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
        this.$refs.alert.showAlert('danger', err.response.data.Message);
      }
      this.showSpinner = false;
    },
    async loadCollateralRemitHistory() {
      this.showSpinner = true;
      try {
        let res                     = await service.getCollateralRemitHistory(this.$store.getters.dealName);
        this.collateralRemitHistory = formatter.formatDataInArray(
          res.data.CollateralRemitHistory,
          ['CurrentBalance'],
          ['Date'],
          [
            'Cpr1Mo',
            'CurrentLossPct',
            'CumulatedLossPct',
            'Delinquency30Pct',
            'Delinquency60Pct',
            'Delinquency90PlusPct',
            'ModifiedBalancePct'
          ],
          ['Factor']
        );
      } catch (err) {
        await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
        this.$refs.alert.showAlert('danger', err.response.data.Message);
      }
      this.showSpinner = false;
    },
    onCashflowGenerated(items) {
      this.collateralCashflow = items.cashflows.CollateralCashflow;
      this.bondsCashflows     = items.cashflows.BondsCashflows;
      this.collateralInfo     = items.collateralInfo;
      this.bondsInfo          = items.bonds;
      this.miscVariables      = items.miscVariables;
      this.$store.commit('saveDealCashflow', {
        collateralCashflow: this.collateralCashflow,
        bondsCashflows:     this.bondsCashflows,
        collateralInfo:     this.collateralInfo,
        bondsInfo:          this.bondsInfo
      });
      this.runDate     = items.runDate;
      this.showSpinner = false;
    },
    onDealFetched(bonds) {
      if (Object.keys(this.$store.getters.dealCashflow.bondsInfo).length === 0) {
        this.bondsInfo = Object.assign({}, bonds);
      }
    },
    onSettlementDateChange() {
      this.collateralCashflow = [];
      this.bondsCashflows     = [];
    }
  },
  components: {
    DealInformation,
    CollateralRemitHistory,
    CapitalStructure,
    Cashflows,
    Alert
  }
};
</script>
